import { IMAGES } from "./images";

export const CONTINUE_LEARNING =[
    {
        id:1,
        title:"Introduction to JavaScript",
        backgroundimage:IMAGES.INTROJS,
        startTime:"17:49",
        endTime:"20:29",
    
    },
    {
        id:2,
        title:"Introduction to JavaScript",
        backgroundimage:IMAGES.INTROJS,
        startTime:"17:49",
        endTime:"20:29",
    
    },
    {
        id:3,
        title:"Introduction to JavaScript",
        backgroundimage:IMAGES.INTROJS,
        startTime:"17:49",
        endTime:"20:29",
    
    },

]